/* eslint-disable */

export default function readMore() {
    //get the description block
    const productDescriptionBlock = document.querySelector('.product__block--description');

    if (!productDescriptionBlock) {
        return;
    }
    //check how many p tags are in the description block
    const productDescriptionBlockChildren = productDescriptionBlock.children;

    if (productDescriptionBlockChildren.length > 2) {
        for (let i = 2; i < productDescriptionBlockChildren.length; i++) {
            productDescriptionBlockChildren[i].classList.add('hidden');
        }

        const readMoreButton = document.createElement('button');
        readMoreButton.classList.add('product__read-more');
        readMoreButton.textContent = 'Read more';
        productDescriptionBlock.appendChild(readMoreButton);

        //add event listener to the read more button
        readMoreButton.addEventListener('click', () => {
            //toggle the hidden class on all p tags except the first two
            for (let i = 2; i < productDescriptionBlockChildren.length - 1; i++) {
                productDescriptionBlockChildren[i].classList.toggle('hidden');
            }

            //change the text of the read more button
            if (readMoreButton.textContent === 'Read more') {
                readMoreButton.textContent = 'Read less';
            } else {
                readMoreButton.textContent = 'Read more';
            }
        });
    }
}